/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface LoginAuthDto {
  username: string;
  password: string;
}

export interface LoginResponse {
  access_token: string;
}

export interface TokenStatusResponseDto {
  status: string;
}

export interface CreateUserDto {
  username: string;
  password: string;
  permissions?: string[];
}

export type ObjectId = object;

export interface UserWithoutPassword {
  _id: ObjectId;
  username: string;
  permissions: string[];
}

export interface UpdateUserDto {
  username?: string;
  password?: string;
  permissions?: string[];
}

export interface User {
  _id: ObjectId;
  username: string;
  password: string;
  permissions: string[];
}

export interface LocalizedText {
  en: string;
  ka: string;
}

export interface CreateProjectDto {
  name: LocalizedText;
  mainImageUrl: string;
  header1: LocalizedText;
  header2?: LocalizedText;
  paragraph1: LocalizedText;
  paragraph2?: LocalizedText;
  imageUrls: string[];
  completed: boolean;
}

export interface Project {
  _id: ObjectId;
  name: LocalizedText;
  mainImageUrl: string;
  header1: LocalizedText;
  header2: LocalizedText;
  paragraph1: LocalizedText;
  paragraph2: LocalizedText;
  imageUrls: string[];
  completed: boolean;
}

export interface UpdateProjectDto {
  name?: LocalizedText;
  mainImageUrl?: string;
  header1?: LocalizedText;
  header2?: LocalizedText;
  paragraph1?: LocalizedText;
  paragraph2?: LocalizedText;
  imageUrls?: string[];
  completed?: boolean;
}

export interface ServiceAccomplishmentCard {
  number: string;
  header: LocalizedText;
  paragraph: LocalizedText;
}

export interface CreateServiceDto {
  name: LocalizedText;
  description: LocalizedText;
  header1: LocalizedText;
  header2: LocalizedText;
  paragraph1: LocalizedText;
  paragraph2: LocalizedText;
  ServiceAccomplishmentCards: ServiceAccomplishmentCard[];
  imageUrls: string[];
}

export interface Service {
  _id: ObjectId;
  name: LocalizedText;
  description: LocalizedText;
  header1: LocalizedText;
  header2: LocalizedText;
  paragraph1: LocalizedText;
  paragraph2: LocalizedText;
  ServiceAccomplishmentCards: ServiceAccomplishmentCard[];
  imageUrls: string[];
}

export interface UpdateServiceDto {
  name?: LocalizedText;
  description?: LocalizedText;
  header1?: LocalizedText;
  header2?: LocalizedText;
  paragraph1?: LocalizedText;
  paragraph2?: LocalizedText;
  ServiceAccomplishmentCards?: ServiceAccomplishmentCard[];
  imageUrls?: string[];
}

export interface Content {
  type: 'video' | 'image' | 'header' | 'paragraph';
  content: LocalizedText;
}

export interface CreateNewsDto {
  title: LocalizedText;
  date: string;
  mainImageUrl: string;
  content: Content[];
}

export interface News {
  _id: ObjectId;
  title: LocalizedText;
  date: string;
  mainImageUrl: string;
  content: Content[];
}

export interface UpdateNewsDto {
  title?: LocalizedText;
  date?: string;
  mainImageUrl?: string;
  content?: Content[];
}

export interface CreateTeamMemberDto {
  fullName: LocalizedText;
  position: LocalizedText;
  description?: LocalizedText;
  imageUrl: string;
}

export interface TeamMember {
  _id: ObjectId;
  fullName: LocalizedText;
  position: LocalizedText;
  description: LocalizedText;
  imageUrl: string;
}

export interface UpdateTeamMemberDto {
  fullName?: LocalizedText;
  position?: LocalizedText;
  description?: LocalizedText;
  imageUrl?: string;
}

export interface CreateSubsidiaryDto {
  name: LocalizedText;
  cardImageUrl: string;
  cardText: LocalizedText;
  website: string;
  header1: LocalizedText;
  header2?: LocalizedText;
  paragraph1: LocalizedText;
  paragraph2?: LocalizedText;
  imageUrls: string[];
}

export interface Subsidiary {
  _id: ObjectId;
  name: LocalizedText;
  cardImageUrl: string;
  cardText: LocalizedText;
  website: string;
  header1: LocalizedText;
  header2: LocalizedText;
  paragraph1: LocalizedText;
  paragraph2: LocalizedText;
  imageUrls: string[];
}

export interface UpdateSubsidiaryDto {
  name?: LocalizedText;
  cardImageUrl?: string;
  cardText?: LocalizedText;
  website?: string;
  header1?: LocalizedText;
  header2?: LocalizedText;
  paragraph1?: LocalizedText;
  paragraph2?: LocalizedText;
  imageUrls?: string[];
}

export interface Accomplishment {
  number: string;
  header: LocalizedText;
  paragraph: LocalizedText;
}

export interface UpdateAboutUsDto {
  header1?: LocalizedText;
  header2?: LocalizedText;
  paragraph1?: LocalizedText;
  paragraph2?: LocalizedText;
  accomplishments?: Accomplishment[];
}

export interface AboutUs {
  _id: ObjectId;
  header1: LocalizedText;
  header2: LocalizedText;
  paragraph1: LocalizedText;
  paragraph2: LocalizedText;
  accomplishments: Accomplishment[];
}

export interface UpdateSubsidiaryPageDto {
  paragraph1?: LocalizedText;
  paragraph2?: LocalizedText;
}

export interface SubsidiaryPage {
  _id: ObjectId;
  paragraph1: LocalizedText;
  paragraph2: LocalizedText;
}

export interface UpdateContactUsDto {
  paragraph?: LocalizedText;
  phone?: string;
  email?: string;
  address?: LocalizedText;
  termsAndConditions?: LocalizedText;
  facebook?: string;
  whatsapp?: string;
  instagram?: string;
}

export interface ContactUs {
  _id: ObjectId;
  paragraph: LocalizedText;
  phone: string;
  email: string;
  address: LocalizedText;
  termsAndConditions: LocalizedText;
  facebook: string;
  whatsapp: string;
  instagram: string;
}

export interface UpdateLandingDto {
  header?: LocalizedText;
  paragraph?: LocalizedText;
  explore?: LocalizedText;
}

export interface Landing {
  _id: ObjectId;
  header: LocalizedText;
  paragraph: LocalizedText;
  explore: LocalizedText;
}

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from 'axios';
import axios from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || '' });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title GUG API
 * @version 1.0
 * @contact
 *
 * OpenApi for GUG
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags App
   * @name GetHello
   * @request GET:/
   */
  getHello = (params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/`,
      method: 'GET',
      format: 'json',
      ...params,
    });

  auth = {
    /**
     * No description
     *
     * @tags Auth
     * @name Login
     * @request POST:/auth/login
     */
    login: (data: LoginAuthDto, params: RequestParams = {}) =>
      this.request<LoginResponse, any>({
        path: `/auth/login`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name GetTokenStatus
     * @request GET:/auth/tokenStatus
     */
    getTokenStatus: (params: RequestParams = {}) =>
      this.request<TokenStatusResponseDto, any>({
        path: `/auth/tokenStatus`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  users = {
    /**
     * No description
     *
     * @tags Users
     * @name Create
     * @request POST:/users
     */
    create: (data: CreateUserDto, params: RequestParams = {}) =>
      this.request<UserWithoutPassword, any>({
        path: `/users`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name FindAll
     * @request GET:/users
     */
    findAll: (params: RequestParams = {}) =>
      this.request<UserWithoutPassword[], any>({
        path: `/users`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name FindOne
     * @request GET:/users/{id}
     */
    findOne: (id: string, params: RequestParams = {}) =>
      this.request<UserWithoutPassword, any>({
        path: `/users/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name Update
     * @request PATCH:/users/{id}
     */
    update: (id: string, data: UpdateUserDto, params: RequestParams = {}) =>
      this.request<UserWithoutPassword, any>({
        path: `/users/${id}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name Remove
     * @request DELETE:/users/{id}
     */
    remove: (id: string, params: RequestParams = {}) =>
      this.request<User, any>({
        path: `/users/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),
  };
  projects = {
    /**
     * No description
     *
     * @tags Projects
     * @name Create
     * @request POST:/projects
     */
    create: (data: CreateProjectDto, params: RequestParams = {}) =>
      this.request<Project, any>({
        path: `/projects`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name FindAll
     * @request GET:/projects
     */
    findAll: (params: RequestParams = {}) =>
      this.request<Project[], any>({
        path: `/projects`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name FindOne
     * @request GET:/projects/{id}
     */
    findOne: (id: string, params: RequestParams = {}) =>
      this.request<Project, any>({
        path: `/projects/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name Update
     * @request PATCH:/projects/{id}
     */
    update: (id: string, data: UpdateProjectDto, params: RequestParams = {}) =>
      this.request<Project, any>({
        path: `/projects/${id}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name Remove
     * @request DELETE:/projects/{id}
     */
    remove: (id: string, params: RequestParams = {}) =>
      this.request<Project, any>({
        path: `/projects/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),
  };
  services = {
    /**
     * No description
     *
     * @tags Services
     * @name Create
     * @request POST:/services
     */
    create: (data: CreateServiceDto, params: RequestParams = {}) =>
      this.request<Service, any>({
        path: `/services`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Services
     * @name FindAll
     * @request GET:/services
     */
    findAll: (params: RequestParams = {}) =>
      this.request<Service[], any>({
        path: `/services`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Services
     * @name FindOne
     * @request GET:/services/{id}
     */
    findOne: (id: string, params: RequestParams = {}) =>
      this.request<Service, any>({
        path: `/services/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Services
     * @name Update
     * @request PATCH:/services/{id}
     */
    update: (id: string, data: UpdateServiceDto, params: RequestParams = {}) =>
      this.request<Service, any>({
        path: `/services/${id}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Services
     * @name Remove
     * @request DELETE:/services/{id}
     */
    remove: (id: string, params: RequestParams = {}) =>
      this.request<Service, any>({
        path: `/services/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),
  };
  news = {
    /**
     * No description
     *
     * @tags News
     * @name Create
     * @request POST:/news
     */
    create: (data: CreateNewsDto, params: RequestParams = {}) =>
      this.request<News, any>({
        path: `/news`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags News
     * @name FindAll
     * @request GET:/news
     */
    findAll: (params: RequestParams = {}) =>
      this.request<News[], any>({
        path: `/news`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags News
     * @name FindOne
     * @request GET:/news/{id}
     */
    findOne: (id: string, params: RequestParams = {}) =>
      this.request<News, any>({
        path: `/news/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags News
     * @name Update
     * @request PATCH:/news/{id}
     */
    update: (id: string, data: UpdateNewsDto, params: RequestParams = {}) =>
      this.request<News, any>({
        path: `/news/${id}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags News
     * @name Remove
     * @request DELETE:/news/{id}
     */
    remove: (id: string, params: RequestParams = {}) =>
      this.request<News, any>({
        path: `/news/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),
  };
  team = {
    /**
     * No description
     *
     * @tags Team
     * @name Create
     * @request POST:/team
     */
    create: (data: CreateTeamMemberDto, params: RequestParams = {}) =>
      this.request<TeamMember, any>({
        path: `/team`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name FindAll
     * @request GET:/team
     */
    findAll: (params: RequestParams = {}) =>
      this.request<TeamMember[], any>({
        path: `/team`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name FindOne
     * @request GET:/team/{id}
     */
    findOne: (id: string, params: RequestParams = {}) =>
      this.request<TeamMember, any>({
        path: `/team/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name Update
     * @request PATCH:/team/{id}
     */
    update: (id: string, data: UpdateTeamMemberDto, params: RequestParams = {}) =>
      this.request<TeamMember, any>({
        path: `/team/${id}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name Remove
     * @request DELETE:/team/{id}
     */
    remove: (id: string, params: RequestParams = {}) =>
      this.request<TeamMember, any>({
        path: `/team/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),
  };
  subsidiaries = {
    /**
     * No description
     *
     * @tags Subsidiary
     * @name Create
     * @request POST:/subsidiaries
     */
    create: (data: CreateSubsidiaryDto, params: RequestParams = {}) =>
      this.request<Subsidiary, any>({
        path: `/subsidiaries`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subsidiary
     * @name FindAll
     * @request GET:/subsidiaries
     */
    findAll: (params: RequestParams = {}) =>
      this.request<Subsidiary[], any>({
        path: `/subsidiaries`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subsidiary
     * @name FindOne
     * @request GET:/subsidiaries/{id}
     */
    findOne: (id: string, params: RequestParams = {}) =>
      this.request<Subsidiary, any>({
        path: `/subsidiaries/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subsidiary
     * @name Update
     * @request PATCH:/subsidiaries/{id}
     */
    update: (id: string, data: UpdateSubsidiaryDto, params: RequestParams = {}) =>
      this.request<Subsidiary, any>({
        path: `/subsidiaries/${id}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subsidiary
     * @name Remove
     * @request DELETE:/subsidiaries/{id}
     */
    remove: (id: string, params: RequestParams = {}) =>
      this.request<Subsidiary, any>({
        path: `/subsidiaries/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),
  };
  aboutUs = {
    /**
     * No description
     *
     * @tags AboutUs
     * @name Upsert
     * @request PUT:/about-us
     */
    upsert: (data: UpdateAboutUsDto, params: RequestParams = {}) =>
      this.request<AboutUs, any>({
        path: `/about-us`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AboutUs
     * @name Find
     * @request GET:/about-us
     */
    find: (params: RequestParams = {}) =>
      this.request<AboutUs, any>({
        path: `/about-us`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  subsidiariesPage = {
    /**
     * No description
     *
     * @tags SubsidiariesPage
     * @name Upsert
     * @request PUT:/subsidiariesPage
     */
    upsert: (data: UpdateSubsidiaryPageDto, params: RequestParams = {}) =>
      this.request<SubsidiaryPage, any>({
        path: `/subsidiariesPage`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SubsidiariesPage
     * @name Find
     * @request GET:/subsidiariesPage
     */
    find: (params: RequestParams = {}) =>
      this.request<SubsidiaryPage, any>({
        path: `/subsidiariesPage`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  contactUs = {
    /**
     * No description
     *
     * @tags ContactUs
     * @name Upsert
     * @request PUT:/contact-us
     */
    upsert: (data: UpdateContactUsDto, params: RequestParams = {}) =>
      this.request<ContactUs, any>({
        path: `/contact-us`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContactUs
     * @name Find
     * @request GET:/contact-us
     */
    find: (params: RequestParams = {}) =>
      this.request<ContactUs, any>({
        path: `/contact-us`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  landing = {
    /**
     * No description
     *
     * @tags Landing
     * @name Upsert
     * @request PUT:/landing
     */
    upsert: (data: UpdateLandingDto, params: RequestParams = {}) =>
      this.request<Landing, any>({
        path: `/landing`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Landing
     * @name Find
     * @request GET:/landing
     */
    find: (params: RequestParams = {}) =>
      this.request<Landing, any>({
        path: `/landing`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  upload = {
    /**
     * No description
     *
     * @tags Upload
     * @name Upload
     * @request POST:/upload
     */
    upload: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/upload`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Upload
     * @name DeleteFile
     * @request DELETE:/upload
     */
    deleteFile: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/upload`,
        method: 'DELETE',
        ...params,
      }),
  };
}
